import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { API } from "../config/api-config";
import { HttpService } from "../service/http-service";

declare var alertify: any;
@Component({
  selector: "app-experience-params",
  templateUrl: "./experience-params.component.html",
  styleUrls: ["./experience-params.component.css"],
})
export class ExperienceParamsComponent implements OnInit {
  constructor(private http: HttpService, private router: Router) {}

  public list: Array<any> = [];
  public imagePath: any;
  public pageData: object = {};
  public page = { pageNumber: 1 };

  ngOnInit() {
    this.getList();
  }

  public edit(id) {
    this.router.navigate(["/index/experienceparams", id]);
  }

  public getList(isSearch = false) {
    let data = { ...this.page, ...this.searchValue };
    data.pageNumber--;
    this.http.getData(API.experienceParamsList, data).then((res) => {
      this.list = res.data.content;
      this.pageData = res.data;
      delete this.pageData["content"];
    });
  }
  public del(id) {
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      () => {
        this.http.deleteData(API.experienceParams + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            this.getList();
          } else {
            alertify.error(res.status.message);
          }
        });
        console.log(id);
      },
      () => {}
    );
  }

  public pageChange(e: any) {
    this.page = e;
    this.getList();
  }

  public searchValue = {
    search: "",
    type: "",
  };

  public searchData() {
    this.page.pageNumber = 1;
    this.getList(true);
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/experience-params/experience-params.component.ts